var websiteConfig = import.meta.env
const currentURL = window.location.href
const hostname = new URL(currentURL).hostname
const subdomain = hostname.split('.')[0]
const extractedSubdomain = (() => {
    let postfixToRemove = import.meta.env.VITE_SUB_DOMAIN_POSTFIX
    // Remove protocol and www (if present)
    let currentURL = window.location.href
    let hostname = new URL(currentURL).hostname
    let subdomain = hostname.split('.')[0]
    // Remove postfix from subdomain
    if (postfixToRemove && subdomain.endsWith(postfixToRemove)) {
      subdomain = subdomain.slice(0, -postfixToRemove.length);
    }
    return subdomain;
  })();

  // console.log(process.env, subdomain, extractedSubdomain);
const rawBackendUrl = import.meta.env.VITE_BACKEND_URL;
const normalizedBackendUrl = rawBackendUrl.endsWith('/') ? rawBackendUrl : rawBackendUrl + '/';

const rawFrontUrl = import.meta.env.VITE_FRONT_URL;
const normalizedFrontUrl = rawFrontUrl.endsWith('/') ? rawFrontUrl : rawFrontUrl + '/';

  websiteConfig = {
    "SubDomain": subdomain,
    "extractedSubdomain": extractedSubdomain,
    "SystemUrl": normalizedBackendUrl+"admin/",
    "FrontUrl": normalizedFrontUrl,
    "BackendUrl": normalizedBackendUrl,
    "allowRequestIntercepts": import.meta.env.VITE_ALLOW_REQUEST_INTERCEPTS,
  }

export default websiteConfig
